import { useIntl } from '@atlassian/jira-intl';
import { type MenuNode, MenuNodeType } from '@atlassian/jira-software-context-menu';
import { SplitIssueType } from '../../../../../../model/modals/types';
import { useBacklogSelector, useBacklogActionCreator } from '../../../../../../state';
import { openModal } from '../../../../../../state/actions/modals';
import { canCreateIssues, canEditIssue } from '../../../../../../state/selectors/permissions';
import { SPLIT_ISSUE_MENU_ID } from '../../constants';
import messages from '../../messages';
import type { Props, ContentProps } from './types';

export const useSplitIssueContent = ({
	onSplitIssue,
	canSplitIssue,
	isMultiSelect,
}: ContentProps): MenuNode[] => {
	const { formatMessage } = useIntl();

	return isMultiSelect || !canSplitIssue
		? []
		: [
				{
					type: MenuNodeType.Item,
					label: formatMessage(messages.splitIssue),
					id: SPLIT_ISSUE_MENU_ID,
					onClick: onSplitIssue,
				},
			];
};

export const useSplitIssue = ({ issueId, isMultiSelect }: Props) => {
	const onSplitIssue = useBacklogActionCreator(() =>
		openModal({
			type: SplitIssueType,
			payload: {
				cardId: issueId,
			},
		}),
	);

	const canCreate = useBacklogSelector(canCreateIssues);
	const canEdit = useBacklogSelector(canEditIssue);
	const canSplitIssue = canCreate && canEdit;

	return useSplitIssueContent({
		onSplitIssue,
		canSplitIssue,
		isMultiSelect,
	});
};
